import React from 'react';
import Component from '@vfuk/core-container-with-label';
const ContainerWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ContainerWithLabel;
